import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import {
  basicCandidatureSchema,
  submitApplicationSchema,
} from "../../services/SchemaService";

import { Form, Loading } from "carbon-components-react";
import SubmitButton from "../../components/Buttons/SubmitButton";
import CancelButton from "../../components/Buttons/CancelButton";
import { ButtonSet } from "carbon-components-react";
import { Edit24, Undo24 } from "@carbon/icons-react";
import { SendAlt24 } from "@carbon/icons-react";
import http from "../../http-common";
import { toast } from "react-toastify";
// import useCandidature from "../../hooks/useCandidature";
import ProjectDetailsForm from "../../components/Forms/ProjectDetailsForm";
import useCandidature from "../../hooks/useCandidature";
import DocumentViewer from "../../components/Forms/DocumentViewer";
import TeamMemberList from "../../components/Forms/TeamMemberList";
import CompanyDetailsForm from "../../components/Forms/CompanyDetailsForm";

const ViewCandidaturePage = () => {
  const { user, isCompetitor } = useAuth();
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { isLoading, candidature } = useCandidature(uuid);
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(basicCandidatureSchema),
    mode: "onSubmit",
  });

  const onSubmit = async (data) => {
    try {
      const response = await http.put("/applications/submit", data);
      navigate("../candidature/" + uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    reset(candidature);
    setIsOpen(candidature.currentStatusCode === 1);
  }, [candidature]);

  const getCandidatureUuid = async () => {
    try {
      const response = await http.get(
        `/applications/uuid-by-phone-number/${user.username}`,
      );
      navigate(
        response.data
          ? "../candidature/" + response.data
          : "../create-candidature",
      );
    } catch (error) {
      navigate("../create-candidature");
    }
  };

  useEffect(() => {
    if (isSubmitted && Object.keys(errors).length > 0) {
      toast.error(
        "Erro de validação do formulário. Verifique se não tem campos obrigatórios não preenchidos",
      );
    }
  }, [isSubmitted, errors]);

  useEffect(() => {
    if (isCompetitor && uuid == "redirect") {
      getCandidatureUuid();
    }
  }, []);

  return (
    <>
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Card title="Candidatura">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <CompanyDetailsForm
            register={register}
            control={control}
            errors={errors}
            disabled={true}
            candidature={candidature}
          />
          <ProjectDetailsForm
            register={register}
            errors={errors}
            disabled={true}
            candidature={candidature}
          />
          <TeamMemberList applicationUuid={uuid} />
          <DocumentViewer applicationUuid={uuid} />
          <div className="form-buttons">
            <ButtonSet>
              {/* {isOpen && (
                <SubmitButton
                  type="button"
                  label="Editar"
                  className="emprega-bg-green"
                  icon={Edit24}
                  onClick={() => navigate("../update-candidature/" + uuid)}
                />
              )} */}
              <CancelButton
                navigateTo={isCompetitor ? "../home" : "../candidatures"}
                icon={Undo24}
                label="Voltar"
              />
              {/* <Link
                className="bx--btn bx--btn--primary"
                style={{ marginRight: "5px" }}
                to={"../pontuar-candidatura/" + uuid}
                target="_blank"
              >
                Pontuar
              </Link> */}
            </ButtonSet>
            {/* {isOpen && (
              <ButtonSet>
                <SubmitButton label="Submeter" icon={SendAlt24} />
              </ButtonSet>
            )} */}
          </div>
        </Form>
      </Card>
    </>
  );
};

export default ViewCandidaturePage;
